import type { PerformanceIndicatorItem } from './types/indicator-description'

import { defineApi } from '#/api/define-api'
import { requestClient } from '#/api/request'

export const performanceIndicatorApi = defineApi('operation', ({ prefix }) => {
  /**
   * 绩效指标列表
   * POST /gobestads/operation/adsPerformance/indicator/query
   */
  function getIndicatorList() {
    return requestClient
      .post(prefix('adsPerformance/indicator/query'), {})
      .then((res) => {
        return {
          list:
            res.list?.map((item: PerformanceIndicatorItem) => ({
              id: item.id,
              indicatorName: item.indicatorName,
              indicatorDesc: item.indicatorDesc,
              formula: item.formula,
            })) || [],
          total: res.total,
          pageIndex: res.pageIndex,
          pageSize: res.pageSize,
        }
      })
  }

  return {
    getIndicatorList,
  }
})
